module.exports = __webpack_public_path__ + "static/media/mdz-main.a861b928.png";